import React, { useEffect, useState } from "react";
import { Button, Offcanvas, Modal, Row, Container, Col } from "react-bootstrap";
import { Dropdown } from "react-bootstrap";
import MenuIcon from "../assets/svg/MenuIcon";
import MenuIcon1 from "../assets/images/icons/menuicon.png";
import ProfileIcon from "../assets/svg/ProfileIcon";
import TelegramIcon from "../assets/svg/TelegramIcon";
import WalletIcon from "../assets/svg/WalletIcon";
import WhatsappIcon from "../assets/svg/WhatsappIcon";
import BetIcon from "../assets/svg/BetIcon";
import SettingIcon from "../assets/svg/SettingIcon";
import StatementIcon from "../assets/svg/StatementIcon";
// import LogoutIcon from "../assets/svg/LogoutIcon";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../redux/auth/actions";
import logo from "../assets/images/logo.png";
import CashierIcon from "../assets/svg/CashierIcon";
import GamesIcon from "../assets/svg/GamesIcon";
import HomeIcon from "../assets/svg/HomeIcon";
// import RiExchangeFill from "../assets/svg/ProfileIcon";
import Exchange from "../assets/images/games-icon/Exchange.png";
import SportsIcon from "../assets/svg/SportsIcon";
import numberWithCommas from "../utils/numbersWithComma";
import MoonLight from "../assets/images/moon.svg";
import SunLight from "../assets/images/sunny.svg";
import { IoWalletOutline } from "react-icons/io5";
import ExchangeFundsFormPopUp from "../views/components/ExchangeFundsFormPopUp";
import { CasinoProviders } from "../lib/data";
// import Index from "../views/pages/privatePages/exchangepopup";
import { getExposureAmount } from "../redux/auth/actions";
import { getBetMatches, getUserBet } from "../redux/sports/actions";

import bonus from "../assets/images/bonus.png";
import referral from "../assets/images/Referral.png";
import MybetIcon from "../assets/images/mybet-icon.svg";
import RefreshIcon from "../assets/images/refresh-icon.svg";
import UserIcon from "../assets/images/user-icon.svg";
import SettingsIcon from "../assets/images/setting-icon.svg";
import LogoutIcon from "../assets/images/logout-icon.svg";
import LiveIcon from "../assets/images/live-icon.svg";

// import GamesSearchModal from "../views/components/GamesSearchModal";

const HeaderAfterLogin = () => {
  const { isAuth } = useSelector((state) => state.auth);
  const { user, wallet, exposureAmount } = useSelector((state) => state.auth);
  const { betMatches, userBets } = useSelector((state) => state.sports);
  // const betMatches = [
  //   {
  //     exposureAmount: 6438.5,
  //     matchName: "Australia v West Indies",
  //     refMatchId: 10,
  //     totalBets: 2,
  //   },
  // ];
  // const userBets = [
  //   {
  //     odds: 130,
  //     stack: 50,
  //     selectionType: "back",
  //     status: "open",
  //     createdAt: "2022-12-02T03:07:13.000Z",
  //   },
  //   {
  //     odds: 1.23,
  //     stack: 50,
  //     selectionType: "lay",
  //     status: "open",
  //     createdAt: "2022-12-02T03:07:04.000Z",
  //   },
  // ];
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const dispatch = useDispatch();
  const { appDetails } = useSelector((state) => state.app);
  const [showexchangeModal, setShowexchangeModal] = useState(false);
  const [showBetModal, setShowBetModal] = useState(false);
  const [showUserBetModal, setShowUserBetModal] = useState(false);

  const handleCloseModal = () => setShowexchangeModal(false);
  const handleShowModal = () => setShowexchangeModal(true);
  // function handelSubmit() {
  //   return <Index />;
  // }
  const [showToggle, setShowToggle] = useState(true);
  useEffect(() => {
    if (showToggle) {
      document.body.classList.add("header_open");
    } else {
      document.body.classList.remove("header_open");
    }
  }, [showToggle]);
  useEffect(() => {
    // dispatch(getExposureAmount());
    // dispatch(getBetMatches({ status: "pending" }));
    setShowToggle(window.screen.width > 992);
    return () => {};
  }, []);

  const handleRowClick = (item) => {
    dispatch(
      getUserBet({
        skip: 0,
        pageSize: 10,
        refmatchid: item?.refMatchId,
      })
    );
    setShowBetModal(false);
    setShowUserBetModal(true);
  };

  const [showLightModeToggle, setShowLightModeToggle] = useState(false);
  useEffect(() => {
    if (showLightModeToggle) {
      document.body.classList.add("light-mode");
    } else {
      document.body.classList.remove("light-mode");
    }
  }, [showLightModeToggle]);

  const [showLeftbarToggle, setShowLeftbarToggle] = useState(false);
  useEffect(() => {
    if (showLeftbarToggle) {
      document.body.classList.add("leftbat-opened");
    } else {
      document.body.classList.remove("leftbat-opened");
    }
  }, [showLeftbarToggle]);

  return (
    <header className="header aftrlgn">
      <div className="top-header">
        <Container fluid>
          <Row>
            <Col className="col-12">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <div className="logo">
                    <a href="/home">
                      <img src={appDetails?.LOGO_URL} alt="Logo" />
                    </a>
                  </div>

                  {/* <div className="d-none d-md-block">
                    <GamesSearchModal />
                  </div> */}
                </div>

                <div className="headerRight">
                  <div className="my-bets">
                    <a href="/mybets" className="">
                      <img src={MybetIcon} alt="mybet icon" />
                      Bets
                    </a>
                  </div>
                  {/* <div className="d-md-none">
                    <GamesSearchModal />
                  </div> */}
                  <div className="my-info">
                    <div className="funds">
                      <ul>
                        {/* <li>
                            <a href="#">
                              <span>Exchange Bal:</span>{" "}
                              <span>
                                IR {numberWithCommas(wallet?.sports || 0)}.00
                              </span>
                            </a>
                          </li> */}
                        <li className="balance">
                          <a href="javascript:void(0)" className="main-bal">
                            <span>Balance:</span>{" "}
                            <span>
                              INR {numberWithCommas(wallet?.cash || 0)}
                            </span>
                          </a>
                          <a
                            href="javascript:void(0)"
                            // onClick={() => setShowBetModal(true)}
                          >
                            <div>
                              <span>Cash:</span>{" "}
                              <span>
                                {numberWithCommas(wallet?.coins)}
                                {/* {numberWithCommas(exposureAmount || 0)}.00 */}
                              </span>
                            </div>
                            <div>
                              <span>Bonus:</span>{" "}
                              <span>{numberWithCommas(wallet?.coins)}</span>
                            </div>
                          </a>
                        </li>
                        {/* <li className="bal-count">
                          +<span>5</span>
                        </li> */}
                      </ul>
                      <a href="javascript:void(0)" className="refresh">
                        <img src={RefreshIcon} alt="refresh icon" />
                      </a>
                    </div>
                    {/* <Button
                        variant="primary menu-btn dropdown-toggle"
                        onClick={handleShow}
                      >
                        <img src={UserIcon} alt="user" /> My Account
                      </Button> */}
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="primary menu-btn dropdown-toggle"
                        id="dropdown-basic"
                      >
                        <span className="my-account">
                          <img src={UserIcon} alt="user" /> My Account
                        </span>
                        <span className="setting">
                          <img src={SettingsIcon} alt="stting icon" />
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <h6 className="user">
                          {user?.mstruserid}
                          <span class="gmt" title="Time Zone">
                            GMT+5:30
                          </span>
                        </h6>
                        <Dropdown.Item href="/profile">
                          My Profile
                        </Dropdown.Item>
                        <Dropdown.Item href="/referral">Referral</Dropdown.Item>
                        <Dropdown.Item href="/bonus">Bonus</Dropdown.Item>
                        <Dropdown.Item href="/mybets">
                          Bets History
                        </Dropdown.Item>
                        <Dropdown.Item href="/cashier">
                          Account Statement
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="#"
                          className="logout"
                          onClick={() => dispatch(logoutUser())}
                        >
                          <span>
                            Logout <img src={LogoutIcon} alt="logout icon" />
                          </span>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="bottom_head d-none d-lg-block">
        <Container fluid>
          <Row>
            <Col xs={12} className="px-0">
              <ul>
                <li>
                  <a href="/home" className="active">
                    <span>Home</span>
                  </a>
                </li>
                <li>
                  <a href="/exchange/Inplay">
                    <span>In-Play</span>
                  </a>
                </li>
                <li>
                  <a href="/exchange/Cricket">
                    <span>Cricket</span>
                    {/* <div className="live-match">
                      <img src={LiveIcon} alt="live-icon" />
                      <span>2</span>
                    </div> */}
                  </a>
                </li>
                <li>
                  <a href="/exchange/Soccer">
                    <span>Soccer</span>
                  </a>
                </li>
                <li>
                  <a href="/exchange/Tennis">
                    <span>Tennis</span>
                  </a>
                </li>
                <li>
                  <a href="/exchange/Virtual Cricket">
                    <span>Virtual Cricket</span>
                  </a>
                </li>
                <li>
                  <a href="/exchange/Horse Racing">
                    <span>Horse Racing</span>
                  </a>
                </li>
                <li>
                  <a href="/exchange/Snooker">
                    <span>Snooker</span>
                  </a>
                </li>
                <li>
                  <a href="/exchange/Greyhound Racing">
                    <span>Greyhound Racing</span>
                  </a>
                </li>
                <li className="dark_menu-li">
                  <a href="/casino/ezugi">
                    <span>Casino</span>
                  </a>
                </li>
                <li>
                  <a href="/exchange/Politics">
                    <span>Politics</span>
                  </a>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>

      <Offcanvas show={show} onHide={handleClose} placement={"end"}>
        <Offcanvas.Header closeButton="closeButton" closeVariant="white">
          <Offcanvas.Title>
            <div className="d-flex">
              <div className="profile-img">
                <ProfileIcon />
              </div>
              <div className="user-info">
                <span>{user?.mstruserid}</span>
                <a>{user?.mobileno}</a>
              </div>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="row">
            <div className="col-6">
              <div className="balance mb-1">Main Balance</div>
            </div>
            <div className="col-6">
              <div className="balance-amount mb-1">
                {numberWithCommas(wallet?.cash || 0)}
              </div>
            </div>
            <div className="col-6">
              <div className="balance mb-3">Bonus</div>
            </div>
            <div className="col-6">
              <div className="balance-amount mb-3">
                {numberWithCommas(wallet?.coins) || 0}
              </div>
            </div>
            <div
              className="col-6"
              onClick={() => {
                navigate("/withdraw");
              }}
            >
              <Button variant="primary  w-100">Withdraw</Button>
            </div>
            <div
              className="col-6"
              onClick={() => {
                navigate("/gatewaylist");
              }}
            >
              <Button variant="primary w-100">Deposit</Button>
            </div>
            {/* <div className="col-4">
              <Button variant="primary w-100" onClick={handleShowModal}>
                Exchange
              </Button>
              <ExchangeFundsFormPopUp
                showexchangeModal={showexchangeModal}
                handleCloseModal={handleCloseModal}
              />
            </div> */}
          </div>
          <ul className="menu-items">
            <li>
              <a href="/profile">
                <ProfileIcon />
                <span>Profile</span>
              </a>
            </li>

            <li>
              <a href="/bonus">
                {/* <BetIcon /> */}
                <img src={bonus} style={{ width: "7%", marginRight: "14px" }} />
                <span>Bonus</span>
              </a>
            </li>
            <li>
              <a href="/referral">
                {/* <BetIcon /> */}
                <img
                  src={referral}
                  style={{ width: "7%", marginRight: "14px" }}
                />
                <span>Referral</span>
              </a>
            </li>
            <li>
              <a href="/mybets">
                <BetIcon />
                <span>My Bets</span>
              </a>
            </li>
            <li>
              <a href="/cashier">
                <StatementIcon />
                <span>Account Statement</span>
              </a>
            </li>
            {/* <li>
              <a href="#">
                <SettingIcon />
                <span>Transfer Funds ( For Excahnge)</span>
              </a>
            </li> */}
            {/* <li>
              <a href="/settings">
                <SettingIcon />
                <span>Settings</span>
              </a>
            </li> */}
            <li onClick={() => dispatch(logoutUser())}>
              <a href="/">
                <LogoutIcon />
                <span>Sign Out</span>
              </a>
            </li>
          </ul>
          <ul className="social_links">
            <li>
              <a target="_blank" href={`${appDetails?.TELEGRAM}`}>
                <TelegramIcon />
              </a>
            </li>
            {/* <li>
              <div
                onClick={() =>
                  window.open(https://wa.me/+917888846060, "_blank")
                }
              >
                <WhatsappIcon />
              </div>
            </li> */}
            <li>
              <a className="panel">
                <WhatsappIcon />
              </a>
            </li>
            <li className="theme-btn">
              <buton
                type="button"
                onClick={() => setShowLightModeToggle((s) => !s)}
              >
                <div className="theme-icon">
                  <img src={MoonLight} alt="Moon Icon" className="dark_theme" />
                  <img src={SunLight} alt="Sun Icon" className="light_theme" />
                </div>
              </buton>
            </li>
          </ul>
        </Offcanvas.Body>
      </Offcanvas>

      <Modal
        className="betslip_popup outer_popup"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showBetModal}
      >
        <Modal.Body>
          {" "}
          <main className="main">
            <div className="container table-responsive">
              <table className="table text-white">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Exposure amount</th>
                    <th scope="col">Match name</th>
                    <th scope="col">Ref match ID</th>
                    <th scope="col">Total bets</th>
                  </tr>
                </thead>
                <tbody>
                  {betMatches &&
                    betMatches.length &&
                    betMatches.map((item, index) => {
                      return (
                        <tr
                          onClick={() => {
                            handleRowClick(item);
                          }}
                        >
                          <th scope="row">{index + 1}</th>
                          <td>{item?.exposureAmount}</td>
                          <td>{item?.matchName}</td>
                          <td>{item?.refMatchId}</td>
                          <td>{item?.totalBets}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </main>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowBetModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>

      <Modal
        className="betslip_popup inner_popup"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showUserBetModal}
      >
        <Modal.Body>
          {" "}
          <main className="main">
            <div className="container table-responsive">
              <table className="table text-white">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Odds</th>
                    <th scope="col">Stack</th>
                    <th scope="col">Selection type</th>
                    <th scope="col">Status</th>
                    <th scope="col">Create date</th>
                  </tr>
                </thead>
                <tbody>
                  {userBets &&
                    userBets.length &&
                    userBets.map((item, index) => {
                      return (
                        <tr>
                          <th scope="row">{index + 1}</th>
                          <td>{item?.odds}</td>
                          <td>{item?.stack}</td>
                          <td>{item?.selectionType}</td>
                          <td>{item?.status}</td>
                          <td>{item?.createdAt}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </main>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowUserBetModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </header>
  );
};

export default HeaderAfterLogin;
